/*
 * @Autor: 可爱又迷人的反派角色
 * @Version: 3.0
 * @Date: 2021-09-23 13:08:40
 * @LastEditTime: 2021-09-26 09:11:15
 * @FilePath: \wechat_ticketing3.0\src\core\use.js
 * @Description:
 */
import Vue from 'vue';
import '../assets/css';

import {
  Lazyload,
  Swipe,
  SwipeItem,
  Skeleton,
  Tab,
  Tabs,
  Image,
  Button,
  Icon,
  Tabbar,
  TabbarItem,
  Panel,
  Field,
  Popup,
  Cell,
  CellGroup,
  Picker,
  Toast,
  Checkbox,
  CheckboxGroup,
  Tag,
  Divider,
  Radio,
  RadioGroup,
  SubmitBar,
  List,
  Overlay,
  Dialog,
  NoticeBar,
  CountDown,
  Stepper,
  Uploader,
  Loading,
  NavBar,
  Row,
  Col,
  Calendar,
  Empty,
  DropdownMenu,
} from 'vant';

Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Skeleton);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Image);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Panel);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Picker);
Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(SubmitBar);
Vue.use(List);
Vue.use(Overlay);
Vue.use(Dialog);
Vue.use(NoticeBar);
Vue.use(CountDown);
Vue.use(Stepper);
Vue.use(Uploader);
Vue.use(Loading);
Vue.use(NavBar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Calendar);
Vue.use(Empty);
Vue.use(DropdownMenu);
